import React from 'react';
import { Notification } from '../NotificationCenter';
import {ReservationHandler} from './handlers/reservationhandler';

interface Props {
  notification: any;
  setNotification: React.Dispatch<React.SetStateAction<any>>;
}

const MainHandler = ({ notification,setNotification }: Props) => {
  if (!notification) {
    return null;
  }
  if (notification.topic === 'reservas') {
    return <ReservationHandler notification={notification} setNotification={setNotification} />;
  }
  return null;
};

export default MainHandler;